<template>
  <div class="container mt-4 px-3">
    <h4 class="mb-3">
      <i class="bi bi-person-plus-fill text-success"></i> Create New Group
    </h4>
    <div class="border-top border-success mb-4"></div>
    <div class="row">
      <!-- Left Section -->
      <div class="col-md-6">
        <div class="mb-3">
          <label class="form-label"><i class="bi bi-envelope"></i> name</label>
          <input type="text" class="form-control" placeholder="name" v-model="name">
        </div>


        <div class="mb-3">
          <label class="form-label"><i class="bi bi-envelope"></i> planall</label>
            <select class="form-select" v-model="planall">
            <option :value="true">true</option>
            <option :value="false">false</option>
            </select>
        </div>

      </div>

      <!-- Right Section -->
      <div class="col-md-6">
       
        <div class="mb-3">
          <label class="form-label"><i class="bi bi-bookmark"></i> Description</label>
          <textarea class="form-control" rows="4" placeholder="Add a description..." v-model="description"></textarea>
        </div>
        
      </div>
    </div>

    <!-- Buttons -->
    <div class="d-flex justify-content-between mt-4">
      <button @click="clearDataGroup()" class="btn btn-danger px-4" >
        <i class="bi bi-brush"></i> Clear
      </button>
      <button @click="createGroup()" class="btn btn-secondary px-4" :disabled="!name ">
        <i class="bi bi-person-plus"></i> Create Group
      </button>
    </div>
  </div>
</template>


<script>
  export default {
    components: {},

      data() {
        return {
          name: "",
          planall: false,
          description: "",
          
        
        
        };
      },
    methods: {
      async clearDataGroup(){
        this.name = "";
        this.planall = "";
        this.description = "";
      },
      async createGroup(){
        try {

          var accessToken = localStorage.getItem("accessToken");
          const response = await fetch(`${process.env.VUE_APP_API_URL}/api/group`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${accessToken}`
              },
              body: JSON.stringify({
                  "name": this.name,
                  "description": this.description,
                  "planall": this.planall
              })
          });

          if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          this.$router.push('/group/list');
          console.log('Group page created:', result);
          } catch (error) {
          console.error('Error creating dashboard page:', error);
          }

      }
   
    },
    created() {
     
    }
  }
</script>

<style scoped>
  /* Add extra styling if needed */
</style>